// extracted by mini-css-extract-plugin
module.exports = {"main":"wechart_main__3JQ3k","container":"wechart_container__3aeSJ"};